module.exports = "/_next/static/files/514d59ba9e945c4613c47af2ff2943cd.png";